import useCallApi from '../../utilities/axios'
import * as umServiceURL from './umServiceURL'

export type ParamType = {
    userID: string
    startDate: string
    endDate: string
    userGroupID: string
}

export type ParamEachFacultyType = {
    userID: string
    startDate: string
    endDate: string
    userGroupID: string
    facultyID: number | null
}

export type ParamDataToExportType = {
    userID: string
    startDate: string
    endDate: string
}

type Translation = { th: string; en: string }

export type ResponseExcel = {
    fileUrl: string
}


export type ResponseInprogress = {
    id: number
    value: number
    label: Translation
    color: string[]
}

export type ResponseStatus = {
    id: number
    value: {
        id: number
        value: number
        label: Translation
    }[]
    label: Translation
    color: string[]
}

export type ResponseOverview = {
    id: number
    number: number
    label: Translation
}

export type ResponseFaculty = {
    id: number
    value: number
    label: Translation
}

export type ResponseEachFaculty = {
    id: number
    value: {
        id: number
        value: number
        label: Translation
        standardLine: number
    }[]
    label: Translation
    color: string[]
}

export type ResponseDataExport = {
    columns: { name: string; group: { name: string } | null }[]
    rows: any[][]
}

export type ResponseDataApproveStatus = {
    id: number
    number: number
    label: Translation
}

const useDashboard = () => {
    const callApi = useCallApi()

    const getExcelReport = async (values: ParamType) => {
        const url = new URL(umServiceURL.getDashboardExcel)
        url.searchParams.set('userID', values?.userID)
        url.searchParams.set('startDate', values?.startDate)
        url.searchParams.set('endDate', values?.endDate)
        const { data } = await callApi.axiosGet<ResponseExcel>({
            url ,
        })

        return data
    }

    const getInprogress = async (values: ParamType) => {
        const url = new URL(umServiceURL.getDBInprogress)
        url.searchParams.set('userID', values?.userID)
        url.searchParams.set('startDate', values?.startDate)
        url.searchParams.set('endDate', values?.endDate)
        url.searchParams.set('userGroupID', values?.userGroupID)
        const { data } = await callApi.axiosGet<ResponseInprogress[]>({
            url,
        })

        return data
    }

    const getAverageStatus = async (values: ParamType) => {
        const url = new URL(umServiceURL.getDBAverageStatus)
        url.searchParams.set('userID', values?.userID)
        url.searchParams.set('startDate', values?.startDate)
        url.searchParams.set('endDate', values?.endDate)
        url.searchParams.set('userGroupID', values?.userGroupID)
        const { data } = await callApi.axiosGet<ResponseStatus[]>({
            url,
        })

        return data
    }

    const getAverageProject = async (values: ParamType) => {
        const url = new URL(umServiceURL.getDBAverageProject)
        url.searchParams.set('userID', values?.userID)
        url.searchParams.set('startDate', values?.startDate)
        url.searchParams.set('endDate', values?.endDate)
        url.searchParams.set('userGroupID', values?.userGroupID)
        const { data } = await callApi.axiosGet<ResponseInprogress[]>({
            url,
        })

        return data
    }

    const getOverview = async (values: ParamType) => {
        const url = new URL(umServiceURL.getDBOverview)
        url.searchParams.set('userID', values?.userID)
        url.searchParams.set('startDate', values?.startDate)
        url.searchParams.set('endDate', values?.endDate)
        url.searchParams.set('userGroupID', values?.userGroupID)
        const { data } = await callApi.axiosGet<ResponseOverview[]>({
            url,
        })

        return data
    }

    const getAverageFaculty = async (values: ParamType) => {
        const url = new URL(umServiceURL.getDBAverageFaculty)
        url.searchParams.set('userID', values?.userID)
        url.searchParams.set('startDate', values?.startDate)
        url.searchParams.set('endDate', values?.endDate)
        url.searchParams.set('userGroupID', values?.userGroupID)
        const { data } = await callApi.axiosGet<ResponseFaculty[]>({
            url,
        })

        return data
    }

    const getAverageEachFaculty = async (values: ParamEachFacultyType) => {
        const url = new URL(umServiceURL.getDBAverageEachFaculty)
        url.searchParams.set('userID', values?.userID)
        url.searchParams.set('startDate', values?.startDate)
        url.searchParams.set('endDate', values?.endDate)
        url.searchParams.set('userGroupID', values?.userGroupID)
        url.searchParams.set('facultyID', String(values?.facultyID))
        const { data } = await callApi.axiosGet<ResponseEachFaculty[]>({
            url,
        })

        return data
    }

    const getDataToExport = async (values: ParamDataToExportType) => {
        const url = new URL(umServiceURL.getExportData)
        url.searchParams.set('userID', values.userID)
        url.searchParams.set('startDate', values.startDate)
        url.searchParams.set('endDate', values.endDate)
        const { data } = await callApi.axiosGet<{ data: ResponseDataExport[] }>({ url })

        return data.data
    }

    const getDataApproveStatus = async (values: ParamDataToExportType) => {
        const url = new URL(umServiceURL.getDataApproveStatus)
        url.searchParams.set('userID', values.userID)
        url.searchParams.set('startDate', values.startDate)
        url.searchParams.set('endDate', values.endDate)
        const { data } = await callApi.axiosGet<ResponseDataApproveStatus[]>({ url })

        return data
    }

    return {
        getExcelReport,
        getInprogress,
        getAverageStatus,
        getAverageProject,
        getOverview,
        getAverageFaculty,
        getAverageEachFaculty,
        getDataToExport,
        getDataApproveStatus,
    }
}

export default useDashboard
